import { updateBasket } from 'components/basket/shared/basket';
import queryClient from 'setup/react-query/queryClient';
import { GetDeliveryGroupsQueryKey, SubscriptionDeliveryDeliveryGroupModelQueryKey } from 'autogen/swagger/all/hooks';

export default function updateBasketAndCheckout() {
    updateBasket();
    queryClient.invalidateQueries({ queryKey: [GetDeliveryGroupsQueryKey] });
    queryClient.invalidateQueries({ queryKey: [SubscriptionDeliveryDeliveryGroupModelQueryKey] });
}
